<div class="modal-container">
    <div class="modal-header pb-0">
        <h2 class="modal-title">
            <span class="back-btn" (click)="onClose()">
                < </span>
                    <span>{{globalConstants.SYSTEM_REQUEST_VIEW_HISTORY_MODAL}}</span>
                    <span class="text-orange"
                        (mousedown)="onClose()">{{globalConstants.VIEW_HISTORY_VIEW_HISTORY_MODAL}}</span>
        </h2>
        <div class="pull-right d-flex align-items-center">

            <button type="button" class="close btn-close" (mousedown)="onClose()" aria-label="Close">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
    </div>
    <div class="modal-body py-0">
        <div class="need-access-form-container">
            <div class="mt-3" *ngIf="accessData?.data?.type!='mySelf'">
                <label>Staff Name: {{accessData?.data?.personName}}</label>
            </div>
            <div class="table-container">
                <div class="my-depart-table-wrap">
                    <weaccess-table [tableColumns]="historyTableColumns"
                        [tableData]="historyTableData"></weaccess-table>
                </div>
            </div>
        </div>

    </div>
    <div class="modal-footer d-flex justify-content-end">
        <button type="button" class="btn btn-orange"
            (click)="onClose()">{{globalConstants.OK_VIEW_HISTORY_MODAL}}</button>
    </div>
</div>